document.addEventListener('DOMContentLoaded', () => {
  var page = document.querySelector('.p-contact');
  var form = document.getElementById('contactForm');
  if (!page || !form) return;

  var confirmBtn = form.querySelector('[data-contact-confirm]');
  var editBtn = form.querySelector('[data-contact-edit]');
  var sendBtn = form.querySelector('.p-contact-confirm__send');

  var EMAILJS_SERVICE_ID = 'service_h4xrsyc';
  var EMAILJS_TEMPLATE_ID = 'template_2ygpnzk';

  var val = function (name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  };
  var set = function (key, text) {
    var el = form.querySelector('[data-confirm="' + key + '"]');
    if (el) el.textContent = text ? text : '—';
  };

  // 入力項目のバリデーション（checkValidity()に頼らず値を直接判定する）
  var NAME_RE = /^\S+[\s　]+\S+$/;
  var KANA_RE = /^[ァ-ヶー]+[\s　]+[ァ-ヶー]+$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // エラーメッセージ（デザイン準拠）
  var MSG_REQUIRED_INPUT = '＊必須項目のためご入力ください。';
  var MSG_REQUIRED_SELECT = '＊必須項目のため選択してください。';
  var MSG_INVALID_EMAIL = '＊正しいメールアドレスをご入力ください。';

  // 各入力項目の定義。validate() は正常なら空文字、エラー時はメッセージを返す。
  var fieldDefs = [
    {
      name: 'category',
      anchor: 'category',
      validate: function () {
        return form.querySelector('input[name="category"]:checked') ? '' : MSG_REQUIRED_SELECT;
      }
    },
    {
      name: 'name',
      anchor: 'name',
      validate: function () { return NAME_RE.test(val('name')) ? '' : MSG_REQUIRED_INPUT; }
    },
    {
      name: 'kana',
      anchor: 'kana',
      validate: function () { return KANA_RE.test(val('kana')) ? '' : MSG_REQUIRED_INPUT; }
    },
    {
      name: 'email',
      anchor: 'email',
      validate: function () {
        var v = val('email');
        if (!v) return MSG_REQUIRED_INPUT;
        return EMAIL_RE.test(v) ? '' : MSG_INVALID_EMAIL;
      }
    },
    {
      name: 'message',
      anchor: 'message',
      validate: function () { return val('message') ? '' : MSG_REQUIRED_INPUT; }
    }
  ];

  // エラー表示・赤枠を付与する .c-field 要素を取得
  var containerOf = function (def) {
    var el = form.querySelector('[name="' + def.anchor + '"]');
    return el ? el.closest('.c-field') : null;
  };

  // 1項目のエラー表示を更新する（メッセージ生成 → 赤枠・メッセージの付与/除去）
  var renderError = function (def) {
    var container = containerOf(def);
    if (!container) return;

    var message = def.validate();
    var errorEl = container.querySelector('.c-field__error');

    if (message) {
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'c-field__error';
        errorEl.setAttribute('role', 'alert');
        container.appendChild(errorEl);
      }
      errorEl.textContent = message;
      container.classList.add('is-error');
    } else {
      container.classList.remove('is-error');
      if (errorEl) errorEl.parentNode.removeChild(errorEl);
    }
  };

  // 一度でも触れた項目のみエラーを表示する（入力途中でいきなり赤くしない）
  var touched = {};

  fieldDefs.forEach(function (def) {
    var container = containerOf(def);
    if (!container) return;

    var controls = container.querySelectorAll('input, textarea');
    Array.prototype.forEach.call(controls, function (el) {
      var isChoice = el.type === 'radio' || el.type === 'checkbox';

      // フォーカスアウト時に確定チェック
      el.addEventListener('blur', function () {
        touched[def.name] = true;
        renderError(def);
      });

      if (isChoice) {
        // ラジオは選択した時点で判定
        el.addEventListener('change', function () {
          touched[def.name] = true;
          renderError(def);
        });
      } else {
        // テキスト入力は「触れた後」だけ入力に応じてエラーを更新（修正で消える）
        el.addEventListener('input', function () {
          if (touched[def.name]) renderError(def);
        });
      }
    });
  });

  // フォーム全体が正常かどうか（確認画面へボタンの活性判定に使用）
  var isFormValid = function () {
    var allValid = fieldDefs.every(function (def) { return def.validate() === ''; });
    var privacy = form.querySelector('input[name="privacy-agree"]');
    return allValid && !!privacy && privacy.checked;
  };

  // 全項目OKなら確認画面へボタンのdisabledを解除
  var updateConfirmBtnState = function () {
    confirmBtn.disabled = !isFormValid();
  };
  form.addEventListener('input', updateConfirmBtnState);
  form.addEventListener('change', updateConfirmBtnState);
  updateConfirmBtnState();

  // 確認画面へ：入力チェック → 確認内容を反映 → 表示切替
  confirmBtn.addEventListener('click', function () {
    if (!isFormValid()) {
      // 念のため（disabled解除の隙間対策）全項目のエラーを表示して先頭へスクロール
      fieldDefs.forEach(function (def) {
        touched[def.name] = true;
        renderError(def);
      });
      var firstError = form.querySelector('.c-field.is-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var category = form.querySelector('input[name="category"]:checked');
    set('category', category ? category.value : '');
    set('company', val('company'));
    set('department', val('department'));
    set('name', val('name'));
    set('kana', val('kana'));
    set('tel', val('tel'));
    set('email', val('email'));
    set('message', val('message'));

    page.classList.add('is-confirm');
    window.scrollTo({ top: 0 });
  });

  // 修正：フォームへ戻る
  editBtn.addEventListener('click', function () {
    page.classList.remove('is-confirm');
    window.scrollTo({ top: 0 });
  });

  // 送信：EmailJS経由で入力項目を送信
  // ※確認画面のボタンはtype="submit"のため、入力画面でEnter押下されても
  //   ネイティブのフォーム送信が発火する。確認画面到達済み＆バリデーションOKの
  //   場合のみ送信処理を行い、必須未入力でのショートカット遷移を防ぐ。
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!page.classList.contains('is-confirm') || !isFormValid()) return;

    var category = form.querySelector('input[name="category"]:checked');

    var templateParams = {
      category: category ? category.value : '',
      company: val('company'),
      department: val('department'),
      name: val('name'),
      kana: val('kana'),
      tel: val('tel'),
      email: val('email'),
      message: val('message')
    };

    sendBtn.disabled = true;

    emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams)
      .then(function () {
        location.href = '/contact/thanks/';
      })
      .catch(function (error) {
        window.alert('送信に失敗しました。しばらくしてから再度お試しください。');
        console.error('EmailJS send error:', error);
      })
      .finally(function () {
        sendBtn.disabled = false;
      });
  });
});
